module.exports = __webpack_public_path__ + "static/media/user-frame-33_1.88130db0.svg";